class Themes {
    // Light theme
    light = {
        // Common
        '--primary': 'var(--primary-light)',
        '--primary-hover': 'var(--primary-hover-light)',
        '--primary-active': 'var(--primary-active-light)',
        '--secondary': 'var(--secondary-light)',
        '--secondary-active': 'var(--secondary-active-light)',
        '--semi-secondary': 'var(--semi-secondary-light)',
        '--danger': 'var(--danger-light)',
        '--black-shadown': 'var(--black-shadown-light)',
        '--grey-light': 'var(--grey-light-light)',
        '--grey-smoke': 'var(--grey-smoke-light)',
        '--required': 'var(--required-light)',
        '--blue': 'var(--blue-light)',
        '--semi-blue': 'var(--semi-blue-light)',
        '--blue-text': 'var(--blue-text-light)',
        '--hover-bg': 'var(--hover-bg-light)',
        '--hover-and-active-bg': 'var(--hover-and-active-bg-light)',
        '--ms-grey': 'var(--ms-grey-light)',
        '--text-min': 'var(--text-min-light)',
        '--ms-semi-grey': 'var(--ms-semi-grey-light)',
        '--ms-light-grey': 'var(--ms-light-grey-light)',
        '--color-control-label': 'var(--color-control-label-light)',
        '--color-bg-grey': 'var(--color-bg-grey-light)',
        '--color-bg-popup': 'var(--color-bg-popup-light)',
        '--purple': 'var(--purple-light)',
        '--green': 'var(--green-light)',
        '--black': 'var(--black-light)',
        '--black-80': 'var(--black-80-light)',
        '--black-60': 'var(--black-60-light)',
        '--black-40': 'var(--black-40-light)',
        '--black-20': 'var(--black-20-light)',
        '--black-10': 'var(--black-10-light)',
        '--grey': 'var(--grey-light)',
        '--grey-80': 'var(--grey-80-light)',
        '--grey-60': 'var(--grey-60-light)',
        '--grey-40': 'var(--grey-40-light)',
        '--grey-20': 'var(--grey-20-light)',
        '--grey-10': 'var(--grey-10-light)',
        '--grey-5': 'var(--grey-5-light)',
        '--white': 'var(--white-light)',

        // Button
        '--btn-secondary-color': 'var(--btn-secondary-color-light)',
        '--btn-secondary-bg': 'var(--btn-secondary-bg-light)',
        '--btn-danger-bg': 'var(--btn-danger-bg-light)',
        '--btn-danger-hover-bg': 'var(--btn-danger-hover-bg-light)',
        '--btn-danger-active-bg': 'var(--btn-danger-active-bg-light)',
        '--btn-transparent-hover-color': 'var(--btn-transparent-hover-color-light)',
        '--btn-transparent-active-color': 'var(--btn-transparent-active-color-light)',
        '--red': 'var(--red-light)',
        // CheckBox
        '--checkbox-hover-bg': 'var(--checkbox-hover-bg-light)',
        '--checkbox-checked-bg': 'var(--checkbox-checked-bg-light)',
        '--checkbox-disabled-bg': 'var(--checkbox-disabled-bg-light)',
        '--checkbox-default-border': 'var(--checkbox-default-border-light)',
        '--checkbox-hover-border': 'var(--checkbox-hover-border-light)',
        '--checkbox-checked-border': 'var(--checkbox-checked-border-light)',
        '--checkbox-disabled-border': 'var(--checkbox-disabled-border-light)',
        // Radio
        '--radio-hover-bg': 'var(--radio-hover-bg-light)',
        '--radio-checked-bg': 'var(--radio-checked-bg-light)',
        '--radio-disabled-bg': 'var(--radio-disabled-bg-light)',
        '--radio-default-border': 'var(--radio-default-border-light)',
        '--radio-hover-border': 'var(--radio-hover-border-light)',
        '--radio-checked-border': 'var(--radio-checked-border-light)',
        '--radio-disabled-border': 'var(--radio-disabled-border-light)',
        // Button outline
        '--button-primary-outline-hover-bg': 'var(--button-primary-outline-hover-bg-light)',
        '--button-primary-outline-active-bg': 'var(--button-primary-outline-active-bg-light)',
        '--button-secondary-outline-hover-bg': 'var(--button-secondary-outline-hover-bg-light)',
        '--button-danger-outline-hover-bg': 'var(--button-danger-outline-hover-bg-light)',
        '--button-danger-outline-active-bg': 'var(--button-danger-outline-active-bg-light)',
        // Combobox
        '--combobox-hover-bg': 'var(--combobox-hover-bg-light)',
        '--combobox-selected-bg': 'var(--combobox-selected-bg-light)',
        '--combobox-chip-bg': 'var(--combobox-chip-bg-light)',
        '--combobox-chip-bg-hover': 'var(--combobox-chip-bg-hover-light)',
        '--combobox-chip-border': 'var(--combobox-chip-border-light)',
        '--header-dropdown-color': 'var(--header-dropdown-color-light)',
        // Gird
        '--ms-grid-hover-and-selected': 'var(--ms-grid-hover-and-selected-light)',
        '--ms-grid-header-color': 'var(--ms-grid-header-color-light)',
        '--ms-grid__header-color': 'var(--ms-grid__header-color-light)', //màu của tiêu đề trên grid
        '--ms-grid__selected--item-color': 'var(--ms-grid__selected--item-color-light)', //Màu của item được chọn
        '--popup-shadow': 'var(--popup-shadow-light)',
        '--popup-footer-bg': 'var(--popup-footer-bg-light)',
        // Form
        '--menu-wapper-hv': 'var(--menu-wapper-hv-light)',
        // Toast
        '--toast-info-bg': 'var(--toast-info-bg-light)',
        '--toast-success-bg': 'var(--toast-success-bg-light)',
        '--toast-success-icon-bg': 'var(--toast-success-icon-bg-light)',
        '--toast-error-bg': 'var(--toast-error-bg-light)',
        '--toast-error-icon-bg': 'var(--toast-error-icon-bg-light)',
        '--toast-warning-bg': 'var(--toast-warning-bg-light)',
        '--toast-warning-icon-bg': 'var(--toast-warning-icon-bg-light)',
        // Switch
        '--switch-bg': 'var(--switch-bg-light)',
        '--switch-part-bg': 'var(--switch-part-bg-light)',
        '--switch-checked-bg': 'var(--switch-checked-bg-light)',
        // Ky tu
        '--ms-main__text-color': 'var(--ms-main__text-color-light)', //màu chủ yếu của hệ thống
        '--ms-mark__text-color': 'var(--ms-mark__text-color-light)', //màu chữ của đóng dấu
        // Tab
        '--ms-tab__item--active-backgroud': 'var(--ms-tab__item--active-backgroud-light)', //màu nền khi tab được active
        '--ms-tab__item--active-text-color': 'var(--ms-tab__item--active-text-color-light)', //màu chữ của tab khi active
        // Loading form
        '--silver': 'var(--silver-light)',
    }

    // theme dark
    dark = {
        // Common
        '--primary': 'var(--primary-dark)',
        '--primary-hover': 'var(--primary-hover-dark)',
        '--primary-active': 'var(--primary-active-dark)',
        '--secondary': 'var(--secondary-dark)',
        '--secondary-active': 'var(--secondary-active-dark)',
        '--semi-secondary': 'var(--semi-secondary-dark)',
        '--danger': 'var(--danger-dark)',
        '--black-shadown': 'var(--black-shadown-dark)',
        '--grey-light': 'var(--grey-light-dark)',
        '--grey-smoke': 'var(--grey-smoke-dark)',
        '--required': 'var(--required-dark)',
        '--blue': 'var(--blue-dark)',
        '--semi-blue': 'var(--semi-blue-dark)',
        '--blue-text': 'var(--blue-text-dark)',
        '--hover-bg': 'var(--hover-bg-dark)',
        '--hover-and-active-bg': 'var(--hover-and-active-bg-dark)',
        '--ms-grey': 'var(--ms-grey-dark)',
        '--text-min': 'var(--text-min-dark)',
        '--ms-semi-grey': 'var(--ms-semi-grey-dark)',
        '--ms-light-grey': 'var(--ms-light-grey-dark)',
        '--color-control-label': 'var(--color-control-label-dark)',
        '--color-bg-grey': 'var(--color-bg-grey-dark)',
        '--color-bg-popup': 'var(--color-bg-popup-dark)',
        '--red': 'var(--red-dark)',
        '--purple': 'var(--purple-dark)',
        '--green': 'var(--green-dark)',
        '--black': 'var(--black-dark)',
        '--black-80': 'var(--black-80-dark)',
        '--black-60': 'var(--black-60-dark)',
        '--black-40': 'var(--black-40-dark)',
        '--black-20': 'var(--black-20-dark)',
        '--black-10': 'var(--black-10-dark)',
        '--grey': 'var(--grey-dark)',
        '--grey-80': 'var(--grey-80-dark)',
        '--grey-60': 'var(--grey-60-dark)',
        '--grey-40': 'var(--grey-40-dark)',
        '--grey-20': 'var(--grey-20-dark)',
        '--grey-10': 'var(--grey-10-dark)',
        '--grey-5': 'var(--grey-5-dark)',
        '--white': 'var(--white-dark)',

        // Button
        '--btn-secondary-color': 'var(--btn-secondary-color-dark)',
        '--btn-secondary-bg': 'var(--btn-secondary-bg-dark)',
        '--btn-danger-bg': 'var(--btn-danger-bg-dark)',
        '--btn-danger-hover-bg': 'var(--btn-danger-hover-bg-dark)',
        '--btn-danger-active-bg': 'var(--btn-danger-active-bg-dark)',
        '--btn-transparent-hover-color': 'var(--btn-transparent-hover-color-dark)',
        '--btn-transparent-active-color': 'var(--btn-transparent-active-color-dark)',
        // CheckBox
        '--checkbox-hover-bg': 'var(--checkbox-hover-bg-dark)',
        '--checkbox-checked-bg': 'var(--checkbox-checked-bg-dark)',
        '--checkbox-disabled-bg': 'var(--checkbox-disabled-bg-dark)',
        '--checkbox-default-border': 'var(--checkbox-default-border-dark)',
        '--checkbox-hover-border': 'var(--checkbox-hover-border-dark)',
        '--checkbox-checked-border': 'var(--checkbox-checked-border-dark)',
        '--checkbox-disabled-border': 'var(--checkbox-disabled-border-dark)',
        // Radio
        '--radio-hover-bg': 'var(--radio-hover-bg-dark)',
        '--radio-checked-bg': 'var(--radio-checked-bg-dark)',
        '--radio-disabled-bg': 'var(--radio-disabled-bg-dark)',
        '--radio-default-border': 'var(--radio-default-border-dark)',
        '--radio-hover-border': 'var(--radio-hover-border-dark)',
        '--radio-checked-border': 'var(--radio-checked-border-dark)',
        '--radio-disabled-border': 'var(--radio-disabled-border-dark)',

        // Button outline
        '--button-primary-outline-hover-bg': 'var(--button-primary-outline-hover-bg-dark)',
        '--button-primary-outline-active-bg': 'var(--button-primary-outline-active-bg-dark)',
        '--button-secondary-outline-hover-bg': 'var(--button-secondary-outline-hover-bg-dark)',
        '--button-danger-outline-hover-bg': 'var(--button-danger-outline-hover-bg-dark)',
        '--button-danger-outline-active-bg': 'var(--button-danger-outline-active-bg-dark)',
        // Combobox
        '--combobox-hover-bg': 'var(--combobox-hover-bg-dark)',
        '--combobox-selected-bg': 'var(--combobox-selected-bg-dark)',
        '--combobox-chip-bg': 'var(--combobox-chip-bg-dark)',
        '--combobox-chip-bg-hover': 'var(--combobox-chip-bg-hover-dark)',
        '--combobox-chip-border': 'var(--combobox-chip-border-dark)',
        '--header-dropdown-color': 'var(--header-dropdown-color-dark)',
        // Gird
        '--ms-grid-hover-and-selected': 'var(--ms-grid-hover-and-selected-dark)',
        '--ms-grid-header-color': 'var(--ms-grid-header-color-dark)',
        '--ms-grid__header-color': 'var(--ms-grid__header-color-dark)', //màu của tiêu đề trên grid
        '--ms-grid__selected--item-color': 'var(--ms-grid__selected--item-color-dark)', //Màu của item được chọn
        '--popup-shadow': 'var(--popup-shadow-dark)',
        '--popup-footer-bg': 'var(--popup-footer-bg-dark)',
        // Form
        '--menu-wapper-hv': 'var(--menu-wapper-hv-dark)',
        // Toast
        '--toast-info-bg': 'var(--toast-info-bg-dark)',
        '--toast-success-bg': 'var(--toast-success-bg-dark)',
        '--toast-success-icon-bg': 'var(--toast-success-icon-bg-dark)',
        '--toast-error-bg': 'var(--toast-error-bg-dark)',
        '--toast-error-icon-bg': 'var(--toast-error-icon-bg-dark)',
        '--toast-warning-bg': 'var(--toast-warning-bg-dark)',
        '--toast-warning-icon-bg': 'var(--toast-warning-icon-bg-dark)',
        // Switch
        '--switch-bg': 'var(--switch-bg-dark)',
        '--switch-part-bg': 'var(--switch-part-bg-dark)',
        '--switch-checked-bg': 'var(--switch-checked-bg-dark)',
        // Ky tu
        '--ms-main__text-color': 'var(--ms-main__text-color-dark)', //màu chủ yếu của hệ thống
        '--ms-mark__text-color': 'var(--ms-mark__text-color-dark)', //màu chữ của đóng dấu
        // Tab
        '--ms-tab__item--active-backgroud': 'var(--ms-tab__item--active-backgroud-dark)', //màu nền khi tab được active
        '--ms-tab__item--active-text-color': 'var(--ms-tab__item--active-text-color-dark)', //màu chữ của tab khi active
        // Loading form
        '--silver': 'var(--silver-dark)',
    }
}

export default new Themes();